<template>
  <div class="news-container">
    <div class="header">
      <div class="title">
        <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x6.png" alt="">
        <span>师资<span class="highlight">力量</span></span>
        <div class="ll"></div>
        <span class="lll">TEACHERS </span>
      </div>
      <div @click="goNext('/facultyPartner')" class="more">
        查看更多 <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x7.png" alt="">
      </div>
    </div>
    <div class="team-container">
      <div class="member-card" v-for="(member, index) in members" :key="index" @click="goDetail(member)" >
        <img :src ="member.terImg" alt="头像" class="avatar" style="object-fit: cover;" />
      <div class="info">
        <div class="name ellipsis">{{ member.isRecommend ? member.userName : member.nickname }}</div>
        <div class="desc ellipsis">{{ member.jobTitle }}</div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { Know } from '@/api/know'
const know = new Know()
import { queryAllArticle } from "@/api/home";
import { DataClient } from '@/api/dataClient'
const dataClient = new DataClient()
import { TeacherClient } from '@/api/teacherClient.js'
import { getDomain } from '@/api/cookies'
let teacherClient = new TeacherClient()
export default {
  name: "NewsDynamic",
  data() {
    return {
      members: []
    };
  },
  created() {
    this.getList()

  },
  methods: {
    goDetail(item) {
      this.$router.push({
        path: '/faculty/teacherDetail',
        query: {
          id: item.id
        }
      })
    },
    async getList() {
      teacherClient.selectPCPageList({
        pageSize: 5,
        pageNum: 1,
      }).then((res) => {
        this.members = res.rows
      })
    }
  }

};
</script>

<style lang="scss" scoped>

.news-container {
  max-width: 1400px;
  margin: 0 auto;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  margin-top: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.title {
  display: flex;
  align-items: center;

  font-family: DingTalk JinBuTi, DingTalk JinBuTi;
  font-weight: 400;
  font-size: 34px;

  img {
    width: 41px;
    margin-right: 9px;
  }

  .ll {
    margin: 0 17px;
    width: 0px;
    height: 28px;
    border-right: 1px solid #BBBBBB;
  }

  .lll {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #999999;
  }
}

.title .icon-news {
  width: 20px;
  height: 20px;
  background-color: #007bff;
  border-radius: 50%;
  margin-right: 8px;
}

.title .highlight {
  color: #007bff;
  margin-left: 4px;
}



.more {
  cursor: pointer;
  display: flex;
  align-items: center;

  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #666666;

  img {
    width: 31px;
    margin-left: 4px;
  }
}


.team-container {
  display: flex;
  justify-content: space-between;
  /* padding: 20px; */
  /* background: #f5f5f5; */
}

.member-card {
  background: #fff;
  border-radius: 10px 10px 16px 16px;

  width: 264px;
  height: 370px;

  cursor: pointer;
  overflow: hidden;



  .avatar {
    width: 264px;
   min-height: 330px;
    background: #FFFFFF;
    border-radius: 10px;
  }

  .info {
    position: absolute;
    width: 264px;
    height: 94px;
    background: #FFFFFF;
    border-radius: 12px ;
    bottom: 0;
    padding: 20px;

    .name {

      font-family: DingTalk JinBuTi, DingTalk JinBuTi;
      font-weight: 400;
      font-size: 21px;
      text-align: center;
      color: #333333;
    }

    .desc {
      text-align: center;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      margin-top: 9px;
    }
  }
}
</style>